import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  RightArrow,
  LeftArrow,
  Section,
  Title,
  TestimonialsLayout,
  TestimonialsContent,
  SlideShow,
  HiddenSlidesProvidingHeight,
  VisibleSlides,
  VisibleSlide,
  InvisibleSlide,
  Quote,
  TestimonialName
} from "./styled/testimonials";

function Testimonials({ title, testimonials }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToIndex = (i) => {
    let nextIndex;
    if (i < 0) {
      nextIndex = testimonials.length - 1;
    } else if (i === testimonials.length) {
      nextIndex = 0;
    } else {
      nextIndex = i;
    }

    setCurrentIndex(nextIndex);
  };

  return (
    <Section>
      <TestimonialsLayout>
        <LeftArrow onClick={() => goToIndex(currentIndex - 1)}>
          <ArrowIcon />
        </LeftArrow>
        <TestimonialsContent>
          <Title>{title}</Title>
          <SlideShow>
            <HiddenSlidesProvidingHeight aria-hidden>
              {testimonials.map((testimonial, i) => (
                <InvisibleSlide key={i}>
                  <Testimonial testimonial={testimonial} />
                </InvisibleSlide>
              ))}
            </HiddenSlidesProvidingHeight>
            <VisibleSlides>
              {testimonials.map((testimonial, i) => (
                <VisibleSlide
                  aria-hidden={i !== currentIndex}
                  isVisible={i === currentIndex}
                  key={i}>
                  <Testimonial testimonial={testimonial} />
                </VisibleSlide>
              ))}
            </VisibleSlides>
          </SlideShow>
        </TestimonialsContent>
        <RightArrow onClick={() => goToIndex(currentIndex + 1)}>
          <ArrowIcon />
        </RightArrow>
      </TestimonialsLayout>
    </Section>
  );
}

Testimonials.propTypes = {
  title: PropTypes.string.isRequired,
  testimonials: PropTypes.array.isRequired
};

const ArrowIcon = (props) => (
  <svg height={27} width={15} {...props}>
    <path
      d="M1.5 1.5l12 12m-12 12l12-12"
      fill="none"
      fillRule="evenodd"
      stroke="#89929d"
      strokeLinecap="square"
      strokeWidth={2}
    />
  </svg>
);

const Testimonial = ({ testimonial }) => (
  <React.Fragment>
    <Quote>{testimonial.quote}</Quote>
    <TestimonialName>
      -{testimonial.name}
      {testimonial.broker && (
        <span dangerouslySetInnerHTML={{ __html: `, ${testimonial.broker}` }} />
      )}
    </TestimonialName>
  </React.Fragment>
);

Testimonial.propTypes = {
  testimonial: PropTypes.shape({
    quote: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired
};

export default Testimonials;
